import { useNavigate } from "react-router-dom";

import { BannerStructure } from "../RootBanner";

export const MyEvoBanner = ({
  onClickLeft,
  onClickRight,
}: {
  onClickLeft: () => void;
  onClickRight: () => void;
}) => {
  const navigate = useNavigate();
  const handleOnClickCTA = () => {
    navigate("/subscription");
  };
  return (
    <BannerStructure
      bgUrl="bg-[url('https://cdn.easysbc.io/fc25/banners/evobanner/evobanner.png')]"
      title=" Automatic tracking, best chains and Meta Ratings for all your evos."
      learnMoreLink="/get-my-evolutions"
      onClickCTA={handleOnClickCTA}
      onClickLeft={onClickLeft}
      onClickRight={onClickRight}
    >
      <div
        className="h-full w-full absolute bottom-0 touch-device:hidden"
        style={{
          background:
            "linear-gradient(0deg, #1A1E23 45.65%, rgba(26, 30, 35, 0.00) 100%)",
        }}
      />
      <div
        className="absolute w-full h-full hidden touch-device:block"
        style={{
          background:
            "linear-gradient(90deg, rgba(26, 30, 35, 0.85) 43.65%, rgba(26, 30, 35, 0.00) 100%)",
        }}
      />
      <img
        className="absolute h-80 touch-device:h-[503px] max-touch-device:left-1/2 max-touch-device:-translate-x-1/2 right-8 -top-8 touch-device:-top-16"
        src={`${import.meta.env.VITE_APP_ASSETS_BASE_URL}/fc25/banners/evobanner/myevobannergraphic.png`}
        alt="evobanner"
      />
    </BannerStructure>
  );
};
